import React from 'react';
import { ButtonTheme, ButtonType } from '@ui-components/PlayButton';
import { SubPage, Variant } from '../CookieConsent';
import { StyledCookieConsentButton } from '../CookieConsent.styles';

export const CookieConsentButtons = ({
    currentPage,
    setCurrentPage,
    onSave,
    onAcceptAll,
    onRejectAll,
    variant,
}: {
    currentPage: SubPage;
    setCurrentPage: (page: SubPage) => void;
    onSave: (e: React.MouseEvent) => void;
    onAcceptAll: (e: React.MouseEvent) => void;
    onRejectAll: (e: React.MouseEvent) => void;
    variant: Variant;
}) => {
    switch (currentPage) {
        case SubPage.Info:
            return (
                <>
                    <StyledCookieConsentButton
                        theme={ButtonTheme.COOKIE_SECONDARY}
                        onClick={() => {
                            setCurrentPage(SubPage.Settings);
                        }}
                        buttonType={ButtonType.BUTTON}
                    >
                        Cookie-Inställningar
                    </StyledCookieConsentButton>
                    {variant !== Variant.TwoLayersNoRejectAll && (
                        <StyledCookieConsentButton
                            theme={ButtonTheme.COOKIE_PRIMARY}
                            onClick={onRejectAll}
                            buttonType={ButtonType.BUTTON}
                        >
                            Avvisa alla
                        </StyledCookieConsentButton>
                    )}
                    <StyledCookieConsentButton
                        theme={ButtonTheme.COOKIE_PRIMARY}
                        onClick={onAcceptAll}
                        buttonType={ButtonType.BUTTON}
                    >
                        Acceptera alla
                    </StyledCookieConsentButton>
                </>
            );
        default:
            return (
                <>
                    <StyledCookieConsentButton
                        theme={ButtonTheme.COOKIE_SECONDARY}
                        onClick={onSave}
                        buttonType={ButtonType.BUTTON}
                    >
                        Spara mina val
                    </StyledCookieConsentButton>
                    {variant === Variant.OneLayerRejectAll && (
                        <StyledCookieConsentButton
                            theme={ButtonTheme.COOKIE_PRIMARY}
                            onClick={onRejectAll}
                            buttonType={ButtonType.BUTTON}
                        >
                            Avvisa alla
                        </StyledCookieConsentButton>
                    )}
                    <StyledCookieConsentButton
                        theme={ButtonTheme.COOKIE_PRIMARY}
                        onClick={onAcceptAll}
                        buttonType={ButtonType.BUTTON}
                    >
                        Acceptera alla
                    </StyledCookieConsentButton>
                </>
            );
    }
};

export default CookieConsentButtons;
